import { render, staticRenderFns } from "./InstanceTopBarTabs.vue?vue&type=template&id=1fecf4e7&scoped=true"
import script from "./InstanceTopBarTabs.vue?vue&type=script&lang=js"
export * from "./InstanceTopBarTabs.vue?vue&type=script&lang=js"
import style0 from "./InstanceTopBarTabs.vue?vue&type=style&index=0&id=1fecf4e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fecf4e7",
  null
  
)

export default component.exports